import React from 'react';
import { BookOpen, Search, Scissors, Calendar, Lock, Shield, Check, X } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function MethodSection() {
  const deliverables = [{
    icon: <BookOpen className="text-gold" size={32} data-id="element-61" />,
    title: 'El Manual Maestro (PDF)',
    desc: 'La guía paso a paso para sanar tus raíces en 7 días.'
  }, {
    icon: <Search className="text-gold" size={32} data-id="element-62" />,
    title: 'Inventario de Repeticiones',
    desc: 'La herramienta para detectar exactamente qué nudo está bloqueando tu dinero hoy.'
  }, {
    icon: <Scissors className="text-gold" size={32} data-id="element-63" />,
    title: 'Protocolo de Liberación',
    desc: 'El acto de fe y las palabras de autoridad para cortar lazos.'
  }, {
    icon: <Calendar className="text-gold" size={32} data-id="element-64" />,
    title: 'Plan de 7 Días de Renovación',
    desc: 'Un cronograma ligero pero profundo para recuperar tu destino.'
  }];
  return <section className="pt-10 pb-8 px-4 bg-cream" data-id="element-65">
      <div className="max-w-5xl mx-auto" data-id="element-66">
        {/* The Unique Mechanism */}
        <div className="text-center mb-20" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal font-bold mb-6" data-id="element-68">
            El Método del Corte de Raíces
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-8" data-id="element-69"></div>

          <div className="max-w-3xl mx-auto space-y-6 text-lg text-charcoal-light" data-id="element-70">
            <p data-id="element-71">
              Es un enfoque híbrido que une la sabiduría espiritual con la
              claridad emocional.{' '}
              <strong className="text-charcoal" data-id="element-72">
                No vamos a juzgar a tu familia; vamos a honrarlos liberándote de
                sus dolores.
              </strong>
            </p>
            <p data-id="element-73">
              Este manual actúa directamente sobre el punto de origen. Al
              identificar la atadura específica y realizar el acto de fe
              correcto, retiras el "permiso legal" que el pasado tiene sobre tu
              presente. No necesitas meses; necesitas un movimiento del alma.
            </p>
          </div>
        </div>

        {/* What You Get */}
        <div data-id="element-74">
          <h3 className="text-2xl font-serif text-charcoal font-bold mb-10 text-center" data-id="element-75">
            Todo lo que recibes hoy:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-76">
            {deliverables.map((item, index) => <div key={index} className="bg-white p-6 md:p-8 border border-gold/20 shadow-sm flex flex-col items-center text-center hover:border-gold/50 transition-colors" data-id="element-77">
                <div className="w-16 h-16 rounded-full bg-cream flex items-center justify-center mb-6 border border-gold/30" data-id="element-78">
                  {item.icon}
                </div>
                <h4 className="text-xl font-serif font-bold text-charcoal mb-3" data-id="element-79">
                  {item.title}
                </h4>
                <p className="text-charcoal-light" data-id="element-80">{item.desc}</p>
              </div>)}
          </div>
        </div>

        {/* Offer & Price block */}
        <div id="price-card" className="mt-16 text-center bg-white p-8 md:p-12 shadow-xl border border-gold/30 relative overflow-hidden max-w-3xl mx-auto" data-id="element-81">
          <div className="mb-8" data-id="element-82">
            <p className="text-sm font-bold tracking-widest text-gold-dark uppercase mb-3" data-id="element-83">
              Precio Especial Hoy
            </p>
            <div className="flex items-baseline justify-center gap-3" data-id="element-84">
              <span className="text-xl text-gray-400 line-through decoration-red-400/50 decoration-2" data-id="element-85">
                $29.99 USD
              </span>
              <div className="flex items-baseline gap-1" data-id="element-86">
                <span className="text-5xl md:text-6xl font-serif font-bold text-charcoal" data-id="element-87">
                  $8.49
                </span>
                <span className="text-lg font-semibold text-charcoal-light" data-id="element-88">
                  USD
                </span>
              </div>
            </div>
          </div>

          <CTAButton pulse href="https://innershiftstore.com/cart/51882289398042:1" text='DESCARGA "CADENAS ROTAS" AHORA' className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" data-id="element-89" />

          <div className="flex flex-col items-center justify-center gap-3 text-sm text-charcoal-light mt-4" data-id="element-90">
            <div className="flex items-center gap-2 font-medium text-green-700 bg-green-50 px-4 py-2 rounded-full" data-id="element-91">
              <Lock size={16} data-id="element-92" />
              COMPRA 100% SEGURA Y PROTEGIDA
            </div>
            <p data-id="element-93">
              Acceso inmediato tras el pago. Garantía de satisfacción de 30 días
              o te devolvemos tu dinero al instante.
            </p>

            {/* Payment methods */}
            <div className="flex items-center justify-center gap-2 mt-3" data-id="element-94">
              <div className="bg-white border border-gray-200 rounded-md h-8 w-14 flex items-center justify-center" data-id="element-95">
                <span className="font-bold text-[#1A1F71] text-[11px] italic tracking-tight" data-id="element-96">
                  VISA
                </span>
              </div>
              <div className="bg-white border border-gray-200 rounded-md h-8 w-14 flex items-center justify-center" data-id="element-97">
                <svg width="24" height="16" viewBox="0 0 24 16" fill="none" data-id="element-98">
                  <circle cx="9" cy="8" r="6" fill="#EB001B" data-id="element-99" />
                  <circle cx="15" cy="8" r="6" fill="#F79E1B" data-id="element-100" />
                  <path d="M12 3.2C13.3 4.3 14.1 6 14.1 8C14.1 10 13.3 11.7 12 12.8C10.7 11.7 9.9 10 9.9 8C9.9 6 10.7 4.3 12 3.2Z" fill="#FF5F00" data-id="element-101" />
                </svg>
              </div>
              <div className="bg-[#FFC439] border border-[#FFC439] rounded-md h-8 w-14 flex items-center justify-center" data-id="element-102">
                <span className="font-extrabold text-[#003087] text-[10px]" data-id="element-103">
                  Pay<span className="text-[#009CDE]" data-id="element-104">Pal</span>
                </span>
              </div>
              <div className="bg-white border border-gray-200 rounded-md h-8 w-14 flex items-center justify-center" data-id="element-105">
                <svg width="36" height="15" viewBox="0 0 36 15" fill="none" data-id="element-106">
                  <path d="M7.2 3.5C6.9 3.9 6.4 4.2 5.9 4.2C5.8 3.7 6.1 3.2 6.3 2.8C6.6 2.4 7.2 2 7.6 2C7.7 2.5 7.5 3 7.2 3.5ZM7.6 4.5C6.8 4.4 6.1 4.9 5.7 4.9C5.3 4.9 4.7 4.5 4.1 4.5C3.2 4.5 2.3 5.1 1.9 5.9C1 7.5 1.6 9.9 2.5 11.2C3 11.8 3.5 12.5 4.2 12.5C4.8 12.5 5.1 12.1 5.8 12.1C6.6 12.1 6.8 12.5 7.5 12.5C8.2 12.5 8.6 11.8 9.1 11.2C9.6 10.5 9.8 9.8 9.8 9.7C9.8 9.7 8.5 9.2 8.5 7.7C8.5 6.5 9.5 5.9 9.6 5.9C9 5 8.2 4.5 7.6 4.5Z" fill="black" data-id="element-107" />
                  <text x="12" y="11" fill="black" fontSize="9" fontFamily="system-ui, -apple-system, sans-serif" fontWeight="600" data-id="element-108">
                    Pay
                  </text>
                </svg>
              </div>
              <div className="bg-black rounded-md h-8 w-14 flex items-center justify-center gap-0.5" data-id="element-109">
                <span className="text-[10px] font-bold" data-id="element-110">
                  <span className="text-[#4285F4]" data-id="element-111">G</span>
                </span>
                <span className="text-white text-[10px] font-semibold" data-id="element-112">
                  Pay
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Who is this for / not for */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mt-16" data-id="element-113">
          <div className="bg-white p-8 border-t-4 border-gold shadow-sm" data-id="element-114">
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-115">
              <span className="bg-gold/20 text-gold-dark p-2 rounded-full" data-id="element-116">
                <Check size={20} data-id="element-117" />
              </span>
              ESTO ES EXACTAMENTE PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-118">
              {['Sientes que hay un "techo invisible" que no te deja prosperar sin importar cuánto te esfuerces.', 'Ves los mismos patrones de tu madre o abuela reflejados en tu propia vida y no sabes cómo romperlos.', 'Tienes fe pero sientes que hay algo que bloquea tus oraciones y tus decretos.', 'Quieres que tus hijos hereden tu bendición, no tus heridas.', 'Estás lista para dedicar 15 minutos al día durante 7 días a tu propia liberación.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal-light" data-id="element-119">
                  <Check className="text-gold shrink-0 mt-1" size={18} data-id="element-120" />
                  <span data-id="element-121">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 border-t-4 border-charcoal-light shadow-sm opacity-90" data-id="element-122">
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-123">
              <span className="bg-gray-100 text-gray-500 p-2 rounded-full" data-id="element-124">
                <X size={20} data-id="element-125" />
              </span>
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-126">
              {['Prefieres culpar a otros en lugar de tomar responsabilidad por tu sanación.', 'Buscas resultados sin ningún tipo de compromiso personal.', 'No estás dispuesta a mirar tu historia familiar con honestidad y amor.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal-light" data-id="element-127">
                  <X className="text-gray-400 shrink-0 mt-1" size={18} data-id="element-128" />
                  <span data-id="element-129">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}